import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { trainerActions } from './trainer.actions';
import { trainerMutations } from './trainer.mutations';
import { trainerState } from './trainer.state';

export default {
  namespaced: true,
  state: trainerState,
  actions: trainerActions,
  mutations: trainerMutations
} as ModuleTree<RootState>;
